// Alert service for showing elegant alerts throughout the app
import React from 'react'
import ReactDOM from 'react-dom'
import Alert from '../components/Alert'

let alertContainer = null
let alertIdCounter = 0
const activeAlerts = new Map()

const createAlertContainer = () => {
  if (!alertContainer) {
    alertContainer = document.createElement('div')
    alertContainer.id = 'alert-container'
    alertContainer.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 10000; pointer-events: none;'
    document.body.appendChild(alertContainer)
  }
  return alertContainer
}

const showAlert = (message, type = 'info', duration = 5000) => {
  const container = createAlertContainer()
  const alertId = alertIdCounter++
  
  const handleClose = () => {
    const alertElement = document.getElementById(`alert-${alertId}`)
    if (alertElement) {
      alertElement.style.animation = 'slideOutRight 0.3s ease'
      setTimeout(() => {
        if (alertElement.parentNode) {
          alertElement.parentNode.removeChild(alertElement)
        }
        activeAlerts.delete(alertId)
      }, 300)
    }
  }

  const alertWrapper = document.createElement('div')
  alertWrapper.id = `alert-${alertId}`
  alertWrapper.style.cssText = 'pointer-events: auto; margin-bottom: 12px;'
  container.appendChild(alertWrapper)

  ReactDOM.render(
    <Alert 
      message={message} 
      type={type} 
      onClose={handleClose}
      duration={duration}
    />,
    alertWrapper
  )

  activeAlerts.set(alertId, alertWrapper)
}

export const alert = {
  success: (message, duration) => showAlert(message, 'success', duration),
  error: (message, duration) => showAlert(message, 'error', duration),
  warning: (message, duration) => showAlert(message, 'warning', duration),
  info: (message, duration) => showAlert(message, 'info', duration),
  // Default to info
  show: (message, duration) => showAlert(message, 'info', duration)
}

export default alert

